import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Paper,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useStore } from 'hooks/useRootStore';
import { FC, useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import UserKeyDelete from '../UserKeyDelete';
import { useStyles } from './styles';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteIcon from '@material-ui/icons/Delete';
import { GridColumns, DataGrid, GridCellParams } from '@material-ui/data-grid';
import { getRowsPerPageOptions } from 'utils/pagination';
import { toFormatDateTime } from 'utils';
import Calender from './../../../assets/icons/EndUser/Calender.svg';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { MenuItem } from '@material-ui/core';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import RefreshIcon from '@material-ui/icons/Refresh';
// import DescriptionIcon from '@material-ui/icons/Description';
import KeyGenerationModal from './KeyGenerationModal';

const EndUserKeyMangement: FC = () => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [copied, setCopied] = useState<string | null>(null);
  const classes = useStyles();
  const { control, handleSubmit } = useForm<any>();
  const [openAdd, setOpenAdd] = useState(false);
  const [openKeyModal, setOpenKeyModal] = useState(false);
  const [openGenerateHelp, setOpenGenerateHelp] = useState(false);
  const swaggerDocumentationUrl = `${window.location.origin}/api/documentation`;

  // const handleDocumentApiClick = () => {
  //   window.open(swaggerDocumentationUrl, '_blank');
  // };

  const handleClickAwayAdd = () => {
    setOpenAdd(false);
  };
  const handleClickAdd = () => {
    setOpenAdd((prev) => !prev);
  };
  const {
    userStore: { user },
    notificationStore: { openNotification },
    endUserSettingsFormStore: {
      ldapKeyGenrate,
      getldapKeyGenrate,
      setclickedKey,
      deleteLdapKeyGenrate,
      endUserconfigKeyModel,
      OauthKeyGenrate,
      getPasswordKeyGenrate,
      getOauthKeyGenrate,
    },
  } = useStore();

  const ldapKeyGenratereq = useMutation((data: any) => ldapKeyGenrate(data), {
    onSuccess: (e) => {
      openNotification('success', 'Secret regenerated successfully');
      getldapKeyGenrateReq.refetch();
    },
    onError: (e) =>
      openNotification(
        'error',
        `Unable to create Private Key for Cloud Directory. Please contact EasyIdentity support`
      ),
  });
  const OauthKeyGenratereq = useMutation((data: any) => OauthKeyGenrate(data), {
    onSuccess: (e) => {
      openNotification('success', 'OAuth key regenerated successfully');
      getldapKeyGenrateReq.refetch();
      setOpenKeyModal(false);
    },
    onError: (e) => openNotification('error', `Unable to create OAuth Key. Please contact EasyIdentity support`),
  });

  const getPasswordKeyGenratereq = useMutation(() => getPasswordKeyGenrate(user?.id), {
    onSuccess: (e) => {
      openNotification('success', 'Password key generated successfully');
      getldapKeyGenrateReq.refetch();
    },
    onError: (e) =>
      openNotification(
        'error',
        `Unable to create Private Key for Cloud Directory. Please contact EasyIdentity support`
      ),
  });
  const getOauthKeyGenratereq = useMutation(() => getOauthKeyGenrate(user?.id), {
    onSuccess: (e) => {
      openNotification('success', 'OAuth key generated successfully');
      getldapKeyGenrateReq.refetch();
    },
    onError: (e) =>
      openNotification(
        'error',
        `Unable to create Private Key for Cloud Directory. Please contact EasyIdentity support`
      ),
  });

  const getldapKeyGenrateReq = useQuery('getldapKeyGenrateReq', () => getldapKeyGenrate(user?.id), {
    onError: (e) => {
      openNotification('error', `Can't Get Cloud Directory User Key info`);
    },
  });

  const deletedapKeyGenrateReq = useMutation(() => deleteLdapKeyGenrate(user?.id), {
    onSuccess: (e) => {
      openNotification('success', `Successfully Deleted Cloud Directory key info`);
      getldapKeyGenrateReq.refetch();
    },
    onError: (e) => {
      openNotification('error', `Can't Delete Cloud Directory key info`);
    },
  });
  useAppPreloader(
    ldapKeyGenratereq.isLoading ||
      getldapKeyGenrateReq.isLoading ||
      getldapKeyGenrateReq.isFetching ||
      deletedapKeyGenrateReq.isLoading ||
      getldapKeyGenrateReq.isFetching ||
      OauthKeyGenratereq.isLoading
  );

  const handleDelete = () => {
    deletedapKeyGenrateReq.mutate();
  };
  const onSubmit = (data: any) => {
    setOpenKeyModal(true);
    setOpenAdd(false);
  };
  const handleCopy = (elementIndex: any) => {
    navigator.clipboard.writeText(elementIndex);
  };
  const rows = useMemo(() => {
    return !getldapKeyGenrateReq.isFetching ? endUserconfigKeyModel : [];
  }, [getldapKeyGenrateReq.isFetching, endUserconfigKeyModel]);
  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);

  const columns: GridColumns = [
    // {
    //   field: 'icon',
    //   headerName: ' ',
    //   width: 60,
    //   align: 'center',
    //   disableColumnMenu: true,
    //   renderCell: (params: GridCellParams) => <KeyIcon style={{ color: 'grey' }} />,
    // },
    {
      field: 'created_at',
      headerName: 'DATE CREATED',
      flex: 1.5,
      renderCell: (params: GridCellParams) => (
        <div style={{ display: 'flex', gap: '10px' }}>
          <img src={Calender} alt='' />
          {toFormatDateTime(params.row.created_at.toString())}
        </div>
      ),
    },
    {
      field: 'client_id',
      headerName: 'CLIENT ID',
      flex: 2,
      width: 250,
      renderCell: (params: any) => (
        <div>
          <IconButton
            size='small'
            className={classes.modelKey}
            onClick={() => {
              handleCopy(params.row.client_id);
              setCopied(`${params.row.client_id}_client_id`);
              setTimeout(() => setCopied(null), 2000);
            }}
            style={{ marginLeft: '8px' }}
          >
            <Tooltip title='Copy Client ID'>
              <FileCopyOutlinedIcon style={{ fontSize: '16px', color: '#007bff' }} />
            </Tooltip>
          </IconButton>
          {copied === `${params.row.client_id}_client_id` && (
            <span style={{ fontSize: '12px', color: '#28a745', marginLeft: '4px' }}>Copied!</span>
          )}
          {params.value}
        </div>
      ),
    },
    {
      field: 'client_secret',
      headerName: 'CLIENT SECRET',
      flex: 3,
      width: 300,
      renderCell: (params: any) => (
        <div>
          <IconButton
            size='small'
            className={classes.modelKey}
            onClick={() => {
              handleCopy(params.row.client_secret);
              setCopied(`${params.row.client_id}_client_secret`);
              setTimeout(() => setCopied(null), 2000);
            }}
            style={{ marginRight: '4px' }}
          >
            <Tooltip title='Copy Client Secret'>
              <FileCopyOutlinedIcon style={{ fontSize: '16px', color: '#007bff' }} />
            </Tooltip>
          </IconButton>
          {copied === `${params.row.client_id}_client_secret` && (
            <span style={{ fontSize: '12px', color: '#28a745', marginLeft: '4px' }}>Copied!</span>
          )}
          {params.value}
        </div>
      ),
    },
    {
      field: 'grant_types',
      headerName: 'Type',
      flex: 1.5,
      renderCell: (params: any) => <div>{params.value}</div>,
    },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      renderCell: (params: GridCellParams) => (
        <div style={{ display: 'flex', gap: '4px' }}>
          <IconButton
            size='small'
            className={classes.btn}
            onClick={() => {
              if (params.row.grant_types === 'password') {
                ldapKeyGenratereq.mutate(params.row.client_id);
              } else {
                OauthKeyGenratereq.mutate(params.row.grant_types);
              }
            }}
          >
            <Tooltip title='Regenerate Secret'>
              <RefreshIcon style={{ fill: '#28a745' }} />
            </Tooltip>
          </IconButton>
          <IconButton
            size='small'
            className={classes.btn}
            onClick={() => {
              setOpenConfirmDialog(true);
              setclickedKey(params.row.client_id);
            }}
          >
            <Tooltip title='Delete Key'>
              <DeleteIcon style={{ fill: '#F44336' }} />
            </Tooltip>
          </IconButton>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.title = 'EasyIdentity: Settings: Rest-Api';
  }, []);

  return (
    <>
      <Grid className={classes.topText}>
        <p>
          Here is a list of private keys for your REST-API client(s). Please keep them secure and do not share them with
          unauthorized entities.
        </p>
        <p>Compromised keys should be deleted. New keys can be generated anytime.</p>
      </Grid>

      <Grid className={classes.topText}>
        <p>
          EasyIdentity provides Swagger API documentation to access and test available APIs directly from the browser.
          Use the credentials provided in the table below,
          <p>
            including the Client ID, Client Secret, and Grant Type = Password, to generate the OAuth access token and
            authorize Swagger before testing APIs.
          </p>
        </p>
      </Grid>
      <div style={{ marginRight: '20px' }}>
        <Button
          variant='contained'
          color='secondary'
          onClick={() => setOpenGenerateHelp(true)}
          style={{ textTransform: 'none' }}
        >
          How to Generate
        </Button>
      </div>

      {!getldapKeyGenrateReq.isFetching && (
        <form>
          <Grid container className={classes.btnbox}>
            {/* <div style={{ marginRight: '20px' }}>
              <Button
                variant="contained"
                color='secondary'
                // startIcon={<DescriptionIcon />}
                onClick={handleDocumentApiClick}
                style={{ textTransform: 'none' }}
              >
                Document API
              </Button>
            </div> */}
            <Controller
              name='customerId'
              defaultValue={user?.id}
              control={control}
              render={({ field }) => (
                <div className={classes.btnBox}>
                  <ClickAwayListener onClickAway={handleClickAwayAdd}>
                    <div>
                      <Button
                        variant='contained'
                        color='secondary'
                        className={classes.btnWideLeft}
                        onClick={handleClickAdd}
                      >
                        <ControlPointIcon />
                      </Button>
                      {openAdd ? (
                        <div className={classes.dropdown}>
                          <MenuItem className={classes.selectItem} onClick={handleSubmit(onSubmit)}>
                            Generate Key
                          </MenuItem>
                        </div>
                      ) : null}
                    </div>
                  </ClickAwayListener>
                </div>
              )}
            />
          </Grid>
        </form>
      )}
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination
          onPageSizeChange={(params) => setPageSize(params.pageSize)}
        />
      </Paper>
      <UserKeyDelete
        label='Delete Key'
        buttonLabel='Confirm'
        action={handleSubmit(handleDelete)}
        openModal={openConfirmDialog}
        handleClose={() => setOpenConfirmDialog(false)}
        gitStatus=''
      />
      <KeyGenerationModal
        open={openKeyModal}
        onClose={() => setOpenKeyModal(false)}
        onPasswordSelect={() => getPasswordKeyGenratereq.mutate()}
        onAuthCodeSelect={() => getOauthKeyGenratereq.mutate()}
        // onAuthCodeSelect={() => OauthKeyGenratereq.mutate('authorization_code')}
      />
      <Dialog open={openGenerateHelp} onClose={() => setOpenGenerateHelp(false)} maxWidth='md' fullWidth>
        <DialogTitle>How to Generate and Use Access Token</DialogTitle>
        <DialogContent dividers>
          <div className={classes.generateSteps}>
            <Typography component='div'>
              <strong>1.</strong> Click on the Swagger URL:{' '}
              <Link href={swaggerDocumentationUrl} target='_blank' rel='noopener'>
                {swaggerDocumentationUrl}
              </Link>
            </Typography>
            <Typography component='div'>
              <strong>2.</strong> Under the OAuth section, locate the <strong>POST /oauth/token</strong> API.
            </Typography>
            <Typography component='div'>
              <strong>3.</strong> Click <strong>Try it out</strong>.
            </Typography>
            <Typography component='div'>
              <strong>4.</strong> Enter the following details in the request body:
            </Typography>
            <div className={classes.generateStepFields}>
              <Typography>Grant Type = password</Typography>
              <Typography>Client ID</Typography>
              <Typography>Client Secret</Typography>
              <Typography>Username</Typography>
              <Typography>Password</Typography>
            </div>
            <Typography component='div'>
              <strong>5.</strong> Click <strong>Execute</strong>.
            </Typography>
            <Typography component='div'>
              <strong>6.</strong> Copy the generated <strong>access_token</strong> from the response.
            </Typography>
            <Typography component='div'>
              <strong>7.</strong> Click the <strong>Authorize</strong> button at the top right corner.
            </Typography>
            <Typography component='div'>
              <strong>8.</strong> Enter:
            </Typography>
            <div className={classes.generateStepFields}>
              <Typography>&lt;Access Token&gt;</Typography>
            </div>
            <Typography component='div'>
              <strong>9.</strong> Click <strong>Authorize</strong>.
            </Typography>
            <Typography component='div'>
              <strong>10.</strong> Click <strong>Close</strong>.
            </Typography>
            <Typography component='div'>
              <strong>11.</strong> Select the required API from the API list.
            </Typography>
            <Typography component='div'>
              <strong>12.</strong> Click <strong>Try it out</strong>.
            </Typography>
            <Typography component='div'>
              <strong>13.</strong> Enter required request details.
            </Typography>
            <Typography component='div'>
              <strong>14.</strong> Click <strong>Execute</strong>.
            </Typography>
            <Typography component='div'>
              <strong>15.</strong> Review:
            </Typography>
            <div className={classes.generateStepFields}>
              <Typography>Response Status</Typography>
              <Typography>Response Message</Typography>
              <Typography>API Response Data</Typography>
            </div>
            <Typography component='div'>
              <strong>16.</strong> If token expires, repeat the token generation steps again.
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenGenerateHelp(false)} color='secondary'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EndUserKeyMangement;
